//React
import React from 'react';
//import * as ReactDOM from 'react-dom';
//Apollo
import { Query } from "react-apollo";
//Components
import GridDay from './../components/GridView/GridDay/GridDay'
import DayListView from "./../components/DayListView/DayListView";
import { Spinner, Stack, Label } from 'office-ui-fabric-react/lib';
import DownloadDialog from './../components/DetailView/DetailPivot/PivotElements/Transscript/DownloadDialog'
import SearchExport from './../components/DetailView/DetailPivot/PivotElements/Transscript/SearchExport'
import { MyContext } from '../context';
import gql from "graphql-tag";

export const queryGetEntry = gql`

        query ent ($id : ID!, $auth:AuthInput, $callStartMs: String, $isHistoryVault: Boolean, $isRefresh: Boolean ) {
          getEntry (input:$auth, id: $id, callStartMs: $callStartMs, isHistoryVault: $isHistoryVault, isRefresh: $isRefresh) {
            id
            versionId
            conversationId
            callEndMs
            scenarioId
            botAppId
            onDemand
            participantCount
            recordingStarts
            recordingStops
            callId
            hasVideo
            hasAudio
            hasChat
            hasFiles
            hasMail
            isHistoryVault
            hasScreenSharing
            hasUserScreen
            hasSMS
            errorSpeechToText
            errorMessage
            isVideoProcessing
            recordingStart
            timein
            timeout
            topic
            day
            duration
            ownerDisplayName
            userId
            botAppId
            recordingType
            mediaAssets
            mediaAssetVideo
            analyticsStatus
            assetStatus
            languageTranscript
            notes
            participantStreams
            needsRequest
            needsApproval
            requestUser
            approvedUser
            approvedUserName
            replayAllowed
            replayRequestUserName 
            ttl
            ttlAudio
            ttlVideo
            ttlScreen
            deleteRequestUser
            deleteRequestUserName
            deleteAllowance
            deleteReasoning
            deleteReasoningText
            deletePropose
            stopReason
            conversationSafe
            isWrapUpCall
            keepDeleteAllowed
            encKeyUrl
            transferorName
            showAbsoluteChatTimes
            storageLocation
            manualMuteSequences{
                isActive
                createdAt
                createdByUserId
                createdByUserName
                startTime
                stopTime
                startId
                stopId
                reason
            }
            conversationSafeFolders{
                id
                name,
                userId,
                supervisors{
                    userId
                }
                exportFolders
            }
            incidents{
                caseId,
                caseName
            }
            aiCategorizationPolicies
            analyticRemark
            tenantId
            participantOffset
            requestReplayReasoningText
            requestRestoreArchiveReasoningText
            archiveStatus
            archiveAllowed
            archiveAccessType
            isRestoreApproved
            isApprover
            isDeleteApproverUser
            hasRestoreStarted
            customFields
            callStartMs
            engagementId
            chatId
            mailInfo
            linkedUser
                 {
                id
                userId
                isRecordingOwner
                isCallOwner
                tenantId
                name
                deviceDisplayName
                detail
                userPrincipal
                photo
                joinDateTime
                leftDateTime
                videoAsset
                audioAsset
                screenAsset
                type
                recordingType
                onBehalfOfUserId
                email
                application
                employeeId
                onPremisesSamAccountName
                }
        summarizedInsights
          {
            categories
            sentiments
                    {
                    sentimentKey
                    appearances
                        {
                        startSeconds
                        endSeconds
                        startTime
                         }

                  }
            labels
                    {
                        name
                        appearances
                            {
                            startSeconds
                            startTime
                          }
                    }
            topics
                    {
                        name
                        referenceUrl
                        appearances
                            {
                            startSeconds
                            startTime
                          }
                    }
            keywords
                    {
                    name
                    isTranscript
                    categorie
                    hasSearchExactKeywords
                    appearances
                        {
                        startSeconds
                        startTime
                        endTime
                        endSeconds
                      }
                  }
            contentUnderstanding
            aiSummary
          }
          waveFormAnalysis
            {
                isAllAudioFileSilence
                isFileZeroLength
                isEveryValueZero
                isStreamNullValue
                isAudioLenghtZero
                endTimeMiliseconds
                rmsAudioSegments
                stepCountAudioSegments
                silenceStartStopList
                    {
                        startTime
                        stopTime
                    }
            }
          unifiedTranscript
               {
              language
              transcript
                   {
                      language
                      reactions
                    {
                        reactionType
                        userId
                    }
                  text
                  type
                  url
                  speakerId
                  speakerUserId
                  changedNote
                  changedTime
                  priority
                  repliedOnContent
                  originalMessageSender
                  originalMessageId
                  messageId
                  instances
                       {
                     start
                      end
                      adjustedStart
                      adjustedEnd
                      absoluteStart
                    }
                }
                speakers {
                    name
                }
            }

          }
        }
    `;
export const queryGetEntryByFolder = gql`

        query ent ($id : ID!, $folderId : ID! $auth:AuthInput, $callStartMs: String, $isRefresh: Boolean ) {
          getEntryByFolder (input:$auth, id: $id, folderId: $folderId, callStartMs: $callStartMs, isRefresh: $isRefresh) {
            id
            conversationId
            scenarioId
            botAppId
            onDemand
            callId
            hasVideo
            hasAudio
            hasChat
            hasFiles
            isHistoryVault
            hasScreenSharing
            recordingStart
            timein
            timeout
            topic
            day
            duration
            userId
            botAppId
            recordingType
            mediaAssets
            mediaAssetVideo
            analyticsStatus
            assetStatus
            languageTranscript
            notes
            participantStreams
            needsRequest
            needsApproval
            requestUser
            approvedUser
            replayAllowed
            ttl
            deleteRequestUser
            deleteAllowance
            deleteReasoning
            deleteReasoningText
            deletePropose
            conversationSafe
            manualMuteSequences{
                isActive
                createdAt
                createdByUserId
                createdByUserName
                startTime
                stopTime
                startId
                stopId
                reason
            }
            conversationSafeFolders{
                id
                name,
                userId,
                supervisors{
                    userId
                }
            }
            incidents{
                caseId,
                caseName
            }
            analyticRemark
            tenantId
            participantOffset
            requestReplayReasoningText
            requestRestoreArchiveReasoningText
            archiveStatus
            archiveAllowed
            archiveAccessType
            isRestoreApproved
            isApprover
            hasRestoreStarted
            customFields
            callStartMs
            callEndMs
            engagementId
            linkedUser
                 {
                id
                userId
                isRecordingOwner
                isCallOwner
                tenantId
                name
                deviceDisplayName
                detail
                userPrincipal
                photo
                joinDateTime
                leftDateTime
                videoAsset
                audioAsset
                type
                recordingType
                }
        summarizedInsights
          {
            categories
            sentiments
                    {
                    sentimentKey
                    appearances
                        {
                        startSeconds
                        endSeconds
                        startTime
                         }

                  }
            labels
                    {
                        name
                        appearances
                            {
                            startSeconds
                            startTime
                          }
                    }
            topics
                    {
                        name
                        referenceUrl
                        appearances
                            {
                            startSeconds
                            startTime
                          }
                    }
            keywords
                    {
                    name
                    isTranscript
                    categorie
                    hasSearchExactKeywords
                    appearances
                        {
                        startSeconds
                        startTime
                        endTime
                        endSeconds
                      }
                  }
            aiSummary
          }
          waveFormAnalysis
            {
                isAllAudioFileSilence
                isFileZeroLength
                isEveryValueZero
                isStreamNullValue
                isAudioLenghtZero
                endTimeMiliseconds
                rmsAudioSegments
                stepCountAudioSegments
                silenceStartStopList
                    {
                        startTime
                        stopTime
                    }
            }
          unifiedTranscript
               {
              language
             
              transcript
                   {
                  reactions
                    {
                        reactionType
                        userId
                    }
                  text
                  type
                  url
                  speakerId
                  speakerUserId
                  changedNote
                  changedTime
                  priority
                  repliedOnContent
                  originalMessageSender
                  originalMessageId
                  messageId
                  instances
                       {
                     start
                      end
                      adjustedStart
                      adjustedEnd
                      absoluteStart
                    }
                }
                speakers {
                    name
                }
            }

          }
        }
    `;

export const queryGetLiveEntry = gql`
        query ent ($id : ID!, $auth:AuthInput) {
          getLiveEntry (input:$auth, id: $id) {
            id
            userId
            conversationId
            scenarioId
            botAppId
            callId
            timein
            topic
            day
            onDemand
            replayAllowed
            hasRestoreStarted
            disableNextRecording
            disableNextRecordingReason
            callStartMs
            activeConversation
            customFields
            rodReasons
            keepDeleteAllowed
            deleteState
            wrapUpDateTime
            hasTimer
            isWrapUpCall
            unifiedTranscript
               {
              transcript
                   {
                  text
                  type
                  speakerId
                  speakerUserId
                  url
                  instances
                       {
                     start
                      end
                      adjustedStart
                      adjustedEnd
                    }
                }
            }
        }
}
    `;

export const queryGetEntryWithJWT = gql`

        query ent ($jwtToken : String,  $callStartMs: String ) {
          getEntryWithJWT (jwtToken: $jwtToken, callStartMs: $callStartMs) {
            id
            versionId
            conversationId
            callEndMs
            scenarioId
            botAppId
            onDemand
            callId
            hasVideo
            hasAudio
            hasChat
            isHistoryVault
            hasFiles
            hasScreenSharing
            hasMetadata
            hasNotes
            errorSpeechToText
            isVideoProcessing
            timein
            timeout
            topic
            day
            duration
            userId
            botAppId
            recordingType
            mediaAssets
            mediaAssetVideo
            analyticsStatus
            assetStatus
            languageTranscript
            notes
            participantStreams
            needsRequest
            needsApproval
            requestUser
            approvedUser
            approvedUserName
            replayAllowed
            replayRequestUserName 
            ttl
            ttlAudio
            ttlVideo
            ttlScreen
            deleteRequestUser
            deleteRequestUserName
            deleteAllowance
            deleteReasoning
            deleteReasoningText
            deletePropose
            stopReason
            conversationSafe
            isWrapUpCall
            keepDeleteAllowed
            encKeyUrl
            transferorName
            storageLocation
            conversationSafeFolders{
                id
                name,
                userId,
                supervisors{
                    userId
                }
                exportFolders
            }
            aiCategorizationPolicies
            analyticRemark
            tenantId
            participantOffset
            requestReplayReasoningText
            requestRestoreArchiveReasoningText
            archiveStatus
            archiveAllowed
            archiveAccessType
            isRestoreApproved
            isApprover
            isDeleteApproverUser
            hasRestoreStarted
            customFields
            callStartMs
            engagementId
            chatId
            linkedUser
                 {
                id
                userId
                isRecordingOwner
                tenantId
                name
                deviceDisplayName
                detail
                userPrincipal
                photo
                joinDateTime
                leftDateTime
                videoAsset
                audioAsset
                type
                recordingType
                onBehalfOfUserId
                email
                application
                }
        summarizedInsights
          {
            categories
            sentiments
                    {
                    sentimentKey
                    appearances
                        {
                        startSeconds
                        endSeconds
                        startTime
                         }

                  }
            labels
                    {
                        name
                        appearances
                            {
                            startSeconds
                            startTime
                          }
                    }
            topics
                    {
                        name
                        referenceUrl
                        appearances
                            {
                            startSeconds
                            startTime
                          }
                    }
            keywords
                    {
                    name
                    isTranscript
                    categorie
                    hasSearchExactKeywords
                    appearances
                        {
                        startSeconds
                        startTime
                        endTime
                        endSeconds
                      }
                  }
            aiSummary
          }
          waveFormAnalysis
            {
                isAllAudioFileSilence
                isFileZeroLength
                isEveryValueZero
                isStreamNullValue
                isAudioLenghtZero
                endTimeMiliseconds
                rmsAudioSegments
                stepCountAudioSegments
                silenceStartStopList
                    {
                        startTime
                        stopTime
                    }
            }
          unifiedTranscript
               {
              language
              transcript
                   {
                      language
                      reactions
                    {
                        reactionType
                        userId
                    }
                  text
                  type
                  url
                  speakerId
                  speakerUserId
                  changedNote 
                  changedTime
                  priority
                  repliedOnContent
                  originalMessageSender
                  originalMessageId
                  messageId
                  instances
                       {
                     start
                      end
                      adjustedStart
                      adjustedEnd
                      absoluteStart
                    }
                }
                speakers {
                    name
                }
            }

          }
        }
    `;


export const queryGetFilterRecordings = gql`
       query getFilterRecordings ($val : String!, $filter: RecordingFilterInputType, $withSave: Boolean, $auth:AuthInput, $path: String, $searchIn: [String]){
          getFilterRecordings(search:$val, filter:$filter, withSave:$withSave, input:$auth, path:$path, searchIn: $searchIn)
          {
            userRules
               {
              blockDeletion
              defaultFilter {
                 id
                 type
                 cycle
                 startDate
                 endDate
                 categories
                 policies
                 persons
                 durationFrom
                 durationTo
              }
              recordingFilter 
              {
                 id
                 type
                 cycle
                 startDate
                 endDate
                 persons
                 defaultFilter
                 userFilter
                 categories
                 integrations
                 application
                 imports
                 policies
                 folders
                 timeBasedType
                 durationFrom
                 durationTo
                 incidentStatus
              }
            }
            statistics 
            {
              count
              inform
            }
            days
               {
              date
              content
              {
                    day
                    timein
                    timeout
                    topic
                    id
                    conversationId
                    policies{
                        policyId
                        monitoredBy
                        riskRating
                    }
                    recordingType
                    duration
                    thumbnail
                    speech2Text
                    notes
                    isVideo
                    hasVideo
                    hasAudio
                    hasChat
                    isHistoryVault
                    hasFiles
                    hasMail
                    hasScreenSharing
                    hasUserScreen
                    hasSMS
                    replayAllowed
                    archiveAllowed
                    archiveAccessType
                    isRestoreApproved
                    isApprover
                    participantCount
                    participantShort
                    callStartMs
                    ownerDisplayName
                    ownerEmail
                    ownerApplicationName
                    linkedUser{
                        id    
                        application
                    }
                    userId
                    archiveStatus
                    hasRestoreStarted
                    customFields
                    conversationSafe
                    scenarioId
                    keepDeleteAllowed
                    deleteState
                    transferorName
                    conversationSafeFolders{
                        id
                        name
                        isCaseManagement
                    }
                    ttl
                    incidents {
                        caseId
                        caseName
                        status
                        riskRating
                        incidentThreadId
                    }
                }
            }
        }
       }
    `;


export const queryRecordings = gql`
     query ent ($auth:AuthInput)
     {
        getRecordings(input:$auth) 
        {
          userRules
             {
              access
              valid
              analytics
              viewType
              blockDeletion
              visibilityDetails
              visibilityDetailsTranscript
              visibilityDetailsAnalytics
              visibilityDetailsAnalyticsChange
              visibilityDetailsNotes
              visibilityDetailsTTL
              visibilityDetailsCustomFields
              visibilityDetailsMetadata
              visibilityDetailsQM
              visibilityDetailsAIAssistant
              visibilityDetailsAIAssistantHistory
              visibilityCleanUp
              availableAIAssistant
              availableOpenQuestion
              availableOpenQuestionLogging
              aiAssistantLanguage
              defaultFilter {
                 id
                 type
                 cycle
                 startDate
                 endDate
                 categories
                 persons
                 policies
                 recordingOwner
                 durationFrom
                 durationTo
              }
              recordingFilter {
                 id
                 type
                 cycle
                 startDate
                 endDate
                 categories
                 persons
                 defaultFilter
                 userFilter
                 integrations
                 application
                 imports
                 policies
                 recordingOwner
                 durationFrom
                 durationTo
                 timeBasedType
                 incidentStatus
              }
              ruleAnalytics {
                withSentiment
                withTranscription
                transcriptLanguage
                translationType
                translationLanguage
                screenAnalysis
                accessType
              }
              ruleAccess {
                userLiveView
                userDenyExport
                userDenyUpload
                userBulkExport
                userBulkRestoreArchive
                userBulkSafe
                userBulkDelete
                userBulkTranscript
                userBulkExcel
                userBulkPasswordLength
                userSafe
                userReporting
                tenantCreate
                tenantChange
                confListUser
                confAddUser
                confTicket
                confTenants
                confUserConfig
                confRulesRecording
                confRulesReplay
                confRulesAccess
                confRulesAnalytics
                confMapUser
                confUserAssignment
                confAssignRecording
                confAssignReplay
                confAssignAccess
                confAssignAnalytics
                userAssignmentUsers
                confAuditLogs
                confJobs
                userKpiWallboard
                archivedRequestRetrievalReasoningRequired
                userCompliancePolicy
                userCompliancePolicyActivate
                userCompliancePolicyEdit
                userCompliancePolicyAssign
                hasCustomFieldsAccess
                customFieldsAccessType
                accesibleCustomFields
                confProfiles
              }
              ruleRecording {
                audioType
                inboundType
                disableNextRecording
                demandStartOnly
              }
              allowedTenants {
                name
                id
            }
          }
          statistics {
            count
            inform
          }
         }
      }
    `;

export const queryAuditConversationReplayed = gql`
    query ent ($id: ID!, $isHistoryVault: Boolean, $replayMode: String) {
        auditConversationReplayed(id: $id, isHistoryVault: $isHistoryVault, replayMode: $replayMode)
    }
`;

export const mutationPerformManualMuting = gql`
                         mutation ent ($auth:AuthInput, $conversationId:String, $tenantId:String){
                            performManualMuting(input:$auth, conversationId:$conversationId, tenantId:$tenantId)
                                   
                              }
                            `;
export const mutationCreateManualMuteSequence = gql`
                         mutation ent ($auth:AuthInput, $conversationId:String, $tenantId:String, $manualMute:ManualMuteSequenceInputType){
                            createManualMuteSequence(input:$auth, conversationId:$conversationId, tenantId:$tenantId, manualMute:$manualMute){
                                 isActive
                                 createdAt
                                 createdByUserId
                                 startTime
                                 stopTime
                                 startId
                                 stopId
                                 reason  
                                }
                              }
                            `;

export const mutationDeleteManualMuteSequences = gql`
                         mutation ent ($auth:AuthInput, $conversationId:String, $tenantId:String, $manualMutes:[ManualMuteSequenceInputType]){
                            deleteManualMuteSequences(input:$auth, conversationId:$conversationId, tenantId:$tenantId, manualMutes:$manualMutes){
                                 isActive
                                 createdAt
                                 createdByUserId
                                 startTime
                                 stopTime
                                 startId
                                 stopId
                                 reason  
                                }
                              }
                            `;

//getFilterRecordings
export const renderSearchTeams = (isGrid, val, filter, withSave, auth, cc, userRules, path, theme, searchIn) => (
    <Query
        query={queryGetFilterRecordings}
        variables={{ val, filter, auth, withSave, path, searchIn }}  >
        {({ loading, error, data }) => {

            if (loading) return <MyContext.Consumer>{(context) => (<div><Spinner label={context.getTranslation("configuration", "loadingConversations")} ariaLive="assertive" labelPosition="top" /></div>)}</MyContext.Consumer>;
            if (error) return <div></div>;
            let cntDays = data.getFilterRecordings.days.length;
            let bulkOperation = userRules.ruleAccess != null && (userRules.ruleAccess.userBulkExport || userRules.ruleAccess.userBulkRestoreArchive || userRules.ruleAccess.userBulkSafe || userRules.ruleAccess.userBulkDelete || userRules.ruleAccess.userBulkTranscript);
            return <MyContext.Consumer>{(context) => (<div >
                {isGrid && <Stack horizontal tokens={{ childrenGap: 5 }}>
                    <div className="app-statistics">{data.getFilterRecordings.statistics.count + " " + context.getTranslation("common", "conversations") + " " + data.getFilterRecordings.statistics.inform}</div>
                    {bulkOperation && data.getFilterRecordings.statistics.count > 0 &&
                        <Stack.Item>
                            <DownloadDialog
                                refetchQueryFields={{ val, filter, auth, withSave, path }}
                                client={cc}
                                authorization={auth}
                                bulkOperation={true}
                                bulkExport={data.getFilterRecordings.days}
                                userRules={userRules}
                                count={data.getFilterRecordings.statistics.count}
                                passwordLength={(userRules.ruleAccess != null && userRules.ruleAccess.userBulkPasswordLength != undefined) ? userRules.ruleAccess.userBulkPasswordLength : 8}
                            />
                        </Stack.Item>
                    }
                    {userRules.ruleAccess != null && !userRules.ruleAccess.userBulkExcel && <Stack.Item>
                        <SearchExport
                            data={data.getFilterRecordings.days}
                            userRules={userRules}
                            apol={cc}
                            count={data.getFilterRecordings.statistics.count}
                        />
                    </Stack.Item>}
                </Stack>}

                {isGrid ? data.getFilterRecordings.days.map(
                    ({ date, content }) => (
                        <GridDay
                            apol={cc}
                            key={date}
                            dayTitle={date}
                            date={date}
                            dayContent={content}
                            authorization={auth}
                            userRules={userRules}
                            cntDays={cntDays}
                            onlyOne={data.getFilterRecordings.statistics.count == 1}
                            theme={theme}
                        />)
                ) : <DayListView
                    refetchQueryFields={{ val, filter, auth, withSave, path, searchIn }}
                    apol={cc}
                    authorization={auth}
                    userRules={userRules}
                    data={data.getFilterRecordings.days}
                    theme={theme}
                    count={data.getFilterRecordings.statistics.count}
                    inform={data.getFilterRecordings.statistics.inform}
                />}
            </div>)}
            </MyContext.Consumer>
        }}
    </Query>
);

export const renderZoomAuthorize = (isGrid, id, filter, withSave, auth, cc, userRules, path, theme) => (
    <Query
        query={gql`
       query ent ($id: String, $path: String){
          authenticateZoom(id: $id, path:$path)
       }
    `}
        variables={{ id, path }}  >
        {({ loading, error, data }) => {

            if (loading) return <MyContext.Consumer>{(context) => (<div><Spinner label={context.getTranslation("configuration", "authenticateWithZoom")} ariaLive="assertive" labelPosition="top" /></div>)}</MyContext.Consumer>;
            if (error) return <MyContext.Consumer>{(context) => (<Stack><Stack.Item align="center"><Label> {context.getTranslation("configuration", "authenticationError")} </Label></Stack.Item></Stack>)}</MyContext.Consumer>;
            return <MyContext.Consumer>{(context) => (<Stack><Stack.Item align="center"><Label> {data.authenticateZoom ? context.getTranslation("configuration", "authenticationSuccess") : context.getTranslation("configuration", "authenticationError")} </Label></Stack.Item></Stack>)}</MyContext.Consumer>;
        }}
    </Query>
);

export const renderWebexAuthorize = (isGrid, id, filter, withSave, auth, cc, userRules, path, theme) => (
    <Query
        query={gql`
       query ent ($id: String, $path: String){
          authenticateWebex(id: $id, path:$path)
       }
    `}
        variables={{ id, path }}  >
        {({ loading, error, data }) => {

            if (loading) return <MyContext.Consumer>{(context) => (<div><Spinner label={context.getTranslation("configuration", "authenticateWithWebex")} ariaLive="assertive" labelPosition="top" /></div>)}</MyContext.Consumer>;
            if (error) return <MyContext.Consumer>{(context) => (<Stack><Stack.Item align="center"><Label> {context.getTranslation("configuration", "webexAuthenticationError")} </Label></Stack.Item></Stack>)}</MyContext.Consumer>;
            return <MyContext.Consumer>{(context) => (<Stack><Stack.Item align="center"><Label> {data.authenticateWebex ? context.getTranslation("configuration", "webexAuthenticationSuccess") : context.getTranslation("configuration", "webexAuthenticationError")} </Label></Stack.Item></Stack>)}</MyContext.Consumer>;
        }}
    </Query>
);
